import get from 'lodash/get';
import ActAmountComputator from './ActAmountComputator';

export default class ManualCorrectionActAmountComputator extends ActAmountComputator {
  compute() {
    return get(this.activity, 'manualCorrection', '0.00');
  }
}
